import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import ITokens from 'interfaces/ITokens';

export async function callApi(email: string, password: string): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.USER}/User/Login`;
	return axios.post(url, { email, password }).toOptionalMapped((x) => x.data);
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = ITokens;
